module.exports = __webpack_public_path__ + "static/media/ruler-triangle.d47a8f1f.svg";